import React from 'react';

/**
 * 显示本地时间
 */
export default class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date()
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.setState({date: new Date()}), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  render() {
    return (<span>{this.state.date.toLocaleTimeString()}</span>);
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Clock.js